import FaultEventsWaveforms from '@/resources/guard-1000-fault-events-waveforms';
import FaultGrabWaveform from '@/resources/guard-1000-fault-grab-waveform';
import { createSeries } from '@/utils/store/phasesFeedersHelpers';
import PaginatedList from './mixins/paginated-list';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import jsona from '@/lib/jsona';

const MODULE_NAME = 'guard1000FaultWaveforms';
const DEFAULT_STATE = {
  eventTimestamp: null,
  latestWaveform: null
};

const baseStore = {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  namespaced: true,
  ...PaginatedList(
    FaultEventsWaveforms,
    {
      state: DEFAULT_STATE,
      actions: {
        async grabWaveform({ commit }, { projectCode, substationCode, externalGuardId }) {
          RootStateCommit(commit, 'startLoading', MODULE_NAME);

          try {
            await FaultGrabWaveform({ projectCode, substationCode, externalGuardId }).save();

            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          } catch (responseError) {
            RootStateCommit(commit, 'setResponseError', MODULE_NAME);
            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          }
        }
      },
      getters: {
        getWaveformSeries: state => createSeries(state.data)
      }
    },
    MODULE_NAME
  )
};

/* This is needed to properly override parseResponse in store */
export default {
  ...baseStore,
  mutations: {
    ...baseStore.mutations,
    parseResponseData(state, data) {
      const { currentPage, totalPages, nextPage, prevPage, totalCount } = camelcaseKeysDeep(
        data.meta
      );
      state.data = Object.freeze(camelcaseKeysDeep(jsona.deserialize(data)));
      state.currentPage = currentPage;
      state.totalPages = totalPages;
      state.nextPage = nextPage;
      state.prevPage = prevPage;
      state.totalCount = totalCount;
      state.loading = false;
    },
    setLatestWaveform(state) {
      if (state.data.length) {
        const { id, timestamp } = state.data[0];

        if (!state.latestWaveform || state.latestWaveform.timestamp < timestamp)
          state.latestWaveform = { id, timestamp };
      }
    },
    setActiveEventTimestamp(state, newTimestamp) {
      state.eventTimestamp = newTimestamp;
    }
  }
};
